<template>
  <div class="train-score-page">
    <div class="train-score-shell">
      <div class="feedback-module">
        <div class="feedback-title-bar">单位教学质量反馈表</div>

        <div class="feedback-card" v-loading="submitting">
          <div class="feedback-intro">
            <p class="intro-title">尊敬的各位学员：</p>
            <p class="intro-content">
              欢迎您参加本期专科护士培训班的学习。为更好地做好专科护士培训工作，使培训班更符合临床护理工作发展的需求，切实协助您解决工作中的难点、疑点，真诚的希望您留下宝贵意见。<br/>谢谢合作！
            </p>
          </div>

          <section class="question-section">
            <div
              v-for="(item, index) in questions"
              :key="item.key"
              class="question-item"
            >
              <h4>{{ index + 1 }}、{{ item.label }}</h4>
              <div class="rate-row">
                <el-rate
                  v-model="form[item.key]"
                  :max="10"
                  :colors="rateColors"
                  :icon-classes="rateIconClasses"
                  void-icon-class="el-icon-success"
                  :low-threshold="2"
                  :high-threshold="8"
                  void-color="#dfe6ef"
                />
                <span class="rate-score">{{ form[item.key] }}分</span>
              </div>
            </div>
          </section>

          <section class="form-section">
            <div class="form-row">
              <h4>您认为还有哪些不足需要改进以及您的建议：</h4>
              <el-input
                v-model.trim="form.advice"
                type="textarea"
                :rows="2"
                resize="none"
                placeholder="请输入您的建议"
              />
            </div>

            <div class="form-row">
              <h4>培训单位：</h4>
              <el-input
                v-model.trim="form.trainBase"
                placeholder="请输入您的培训单位"
              />
            </div>

            <div class="form-row">
              <h4>分数：</h4>
              <el-input :value="String(totalScore)" readonly />
            </div>
          </section>

          <div class="submit-wrap">
            <el-button
              class="submit-btn"
              :loading="submitting"
              :disabled="!arId"
              @click="submitFeedback"
            >
              提交
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

const SUBMITTED_BASE_FEEDBACK_CACHE_KEY = "pc_submitted_base_feedback_ar_ids";
const QUESTION_LIST = [
  { key: "teachAtmosphere", label: "教学氛围浓郁" },
  { key: "teachConsciousness", label: "带教老师教学意识强" },
  { key: "teachAbility", label: "带教老师教学能力强" },
  { key: "teachTechnology", label: "带教老师专业技术过硬" },
  { key: "teachPlan", label: "是否有完善、实用的带教计划" },
  { key: "equipment", label: "仪器设施齐备，利于实践" },
  { key: "treatingDiseases", label: "收治病种能满足教学实践要求" },
  { key: "theoreticalIssues", label: "培训课程中的理论问题能实践中得到应用" },
  { key: "technicalOperation", label: "培训课程中的技术操作能得到实践" },
  { key: "baseTeach", label: "您认为该单位是否符合教学单位的要求" }
];

export default {
  name: "TrainScore",
  data() {
    return {
      submitting: false,
      arId: null,
      questions: QUESTION_LIST,
      form: {
        teachAtmosphere: 10,
        teachConsciousness: 10,
        teachAbility: 10,
        teachTechnology: 10,
        teachPlan: 10,
        equipment: 10,
        treatingDiseases: 10,
        theoreticalIssues: 10,
        technicalOperation: 10,
        baseTeach: 10,
        advice: "",
        trainBase: ""
      },
      rateColors: ["#1b9aee", "#1b9aee", "#1b9aee"],
      rateIconClasses: ["el-icon-success", "el-icon-success", "el-icon-success"]
    };
  },
  computed: {
    totalScore() {
      return this.questions.reduce((sum, item) => {
        const score = Number(this.form[item.key]);
        return sum + (Number.isFinite(score) ? score : 0);
      }, 0);
    }
  },
  created() {
    this.initArId();
  },
  methods: {
    initArId() {
      const arId = Number(this.$route.query.arId);
      if (Number.isFinite(arId) && arId > 0) {
        this.arId = arId;
        return;
      }
      this.arId = null;
      this.$message.warning("报名信息异常，无法提交调查问卷");
    },
    normalizeAdvice(text, fallback = "无") {
      const value =
        text === null || text === undefined ? "" : String(text).trim();
      return value || fallback;
    },
    getSubmittedBaseFeedbackArIdList() {
      try {
        const raw = sessionStorage.getItem(SUBMITTED_BASE_FEEDBACK_CACHE_KEY);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (error) {
        void error;
        return [];
      }
    },
    markBaseFeedbackSubmitted(arId) {
      const currentArId = Number(arId);
      if (!Number.isFinite(currentArId) || currentArId <= 0) {
        return;
      }
      const list = this.getSubmittedBaseFeedbackArIdList();
      if (!list.includes(currentArId)) {
        list.push(currentArId);
      }
      sessionStorage.setItem(
        SUBMITTED_BASE_FEEDBACK_CACHE_KEY,
        JSON.stringify(list)
      );
    },
    buildPayload() {
      return {
        arId: this.arId,
        teachAtmosphere: this.form.teachAtmosphere,
        teachConsciousness: this.form.teachConsciousness,
        teachAbility: this.form.teachAbility,
        teachTechnology: this.form.teachTechnology,
        teachPlan: this.form.teachPlan,
        equipment: this.form.equipment,
        treatingDiseases: this.form.treatingDiseases,
        theoreticalIssues: this.form.theoreticalIssues,
        technicalOperation: this.form.technicalOperation,
        baseTeach: this.form.baseTeach,
        advice: this.normalizeAdvice(this.form.advice),
        trainBase: this.normalizeAdvice(this.form.trainBase, ""),
        score: this.totalScore
      };
    },
    async submitFeedback() {
      if (!this.arId) {
        this.$message.warning("报名信息异常，无法提交调查问卷");
        return;
      }
      if (!this.form.trainBase || !String(this.form.trainBase).trim()) {
        this.$message.warning("请输入您的培训单位名称");
        return;
      }

      try {
        await this.$confirm("确认要提交调查问卷吗？", "提示", {
          confirmButtonText: "确认提交",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        });
      } catch (error) {
        return;
      }

      this.submitting = true;
      try {
        const payload = this.buildPayload();
        const res = await httpRequest("/app/feedback/base", "post", payload);
        if (!(res && res.code === 200)) {
          return;
        }
        this.markBaseFeedbackSubmitted(this.arId);
        this.$message.success("提交成功");
        this.$router.replace("/studyPage");
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.train-score-page {
  min-height: calc(100vh - 77px - 50px);
  padding: 16px 0 30px;
  background: #efeff1;

  .train-score-shell {
    width: 1200px;
    max-width: calc(100% - 40px);
    margin: 0 auto;
  }

  .feedback-module {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    overflow: hidden;
  }

  .feedback-title-bar {
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    background: #4095e5;
    font-weight: 500;
    letter-spacing: 1px;
  }

  .feedback-card {
    padding: 32px 40px 42px;
    text-align: left;
  }

  .feedback-intro {
    color: #444a57;
    font-size: 18px;
    line-height: 1.8;
    border-bottom: 1px dashed #eceff4;
    padding-bottom: 16px;

    p {
      margin: 0;
    }

    .intro-title {
      font-weight: 600;
    }

    .intro-content {
      margin-top: 10px;
      font-weight: 600;
      color: #2f3d52;
    }
  }

  .question-section {
    padding-top: 10px;
  }

  .question-item {
    padding: 20px 0 14px;
    border-bottom: 1px dashed #eceff4;

    h4 {
      margin: 0 0 14px;
      font-size: 16px;
      line-height: 1.5;
      color: #303133;
      font-weight: 600;
    }
  }

  .rate-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 4px;
  }

  .rate-score {
    font-size: 18px;
    color: #e6a23c;
    font-weight: 600;
    line-height: 1;
  }

  .form-section {
    padding-top: 20px;
  }

  .form-row {
    margin-bottom: 14px;

    h4 {
      margin: 0 0 12px;
      font-size: 15px;
      color: #303133;
      line-height: 1.5;
      font-weight: 600;
    }
  }

  .submit-wrap {
    padding-top: 36px;
    text-align: center;
  }

  .submit-btn {
    width: 280px;
    height: 48px;
    border: none;
    border-radius: 24px;
    background: #0f68c4;
    color: #ffffff;
    font-size: 17px;
    font-weight: 500;
    letter-spacing: 2px;
    box-shadow: 0 4px 12px rgba(15, 104, 196, 0.3);

    &:hover:not(:disabled) {
      background: #1275db;
    }
  }

  ::v-deep .el-rate {
    display: inline-flex;
    align-items: center;
    height: 24px;
    line-height: 24px;

    .el-rate__icon {
      margin-right: 6px;
      font-size: 24px;
    }

    .el-rate__item {
      cursor: pointer;
    }
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-textarea__inner {
    font-size: 15px;
    border-color: #dcdfe6;

    &:focus {
      border-color: #4095e5;
    }
  }

  ::v-deep .el-input.is-disabled .el-input__inner,
  ::v-deep .el-input[readonly] .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #909399;
    font-weight: 600;
  }
}

@media (max-width: 1200px) {
  .train-score-page {
    .feedback-card {
      padding: 18px 16px 26px;
    }

    .question-item h4 {
      font-size: 15px;
    }

    .rate-score {
      font-size: 20px;
    }
  }
}
</style>
